<template>
  <div class="activity-box">
    <div class="main">
      <img class="bg" src="./images/bg.png" alt="" />
      <img src="./images/portrait1.webp" alt="" class="portrait1" />
      <img src="./images/portrait2.webp" alt="" class="portrait2" />
      <div class="score-box1">
        <div
          class="item"
          v-for="(item, index) of list.slice(0, 3)"
          :key="index"
        >
          <div class="left">
            <img
              :src="item.cp1_avatar"
              alt=""
              @click="toPlayerDetail(item.cp1_uuid)"
            />
            <img
              :src="item.cp2_avatar"
              alt=""
              @click="toPlayerDetail(item.cp2_uuid)"
            />
            <span class="user-name">{{ item.cp1_nick }}</span
            >&nbsp;與&nbsp;
            <span class="user-name">{{ item.cp2_nick }}</span>
          </div>
          <div class="right">
            <span>月餅數量</span>
            <span class="score">{{ item.jifen }}</span>
          </div>
        </div>
      </div>
      <div class="score-box2">
        <div class="item" v-for="(item, index) of list.slice(3)" :key="index">
          <div class="left">
            <span class="index">{{ index + 4 }}</span>
            <img
              :src="item.cp1_avatar"
              alt=""
              @click="toPlayerDetail(item.cp1_uuid)"
            />
            <img
              :src="item.cp2_avatar"
              alt=""
              @click="toPlayerDetail(item.cp2_uuid)"
            />
            <span class="user-name">{{ item.cp1_nick }}</span
            >&nbsp;與&nbsp;
            <span class="user-name">{{ item.cp2_nick }}</span>
          </div>
          <div class="right">
            <span>月餅數量</span>
            <span class="score">{{ item.jifen }}</span>
          </div>
        </div>
      </div>
      <div class="my-score">我的月餅數量：&nbsp;&nbsp;{{ myScore }}</div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Scoreboard2',
  data() {
    return {
      list: [],
      myScore: 0
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    }
  },
  watch: {
    uuid: {
      handler: function(val) {
        if (val) {
          this.getMyscore(val);
        } else {
          this.myScore = 0;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async getList() {
      try {
        const url = 'https://devops.nicee.app/api/zhongqiu/cp/rank';
        const { data } = await this.$http.get(url);
        this.list = data || [];
      } catch (error) {
        console.log(error);
      }
    },
    async getMyscore(uuid) {
      try {
        const url = `https://devops.nicee.app/api/zhongqiu/rank/${uuid}`;
        const { data } = await this.$http.get(url);
        if (data) {
          this.myScore = data.jifen || 0;
        }
      } catch (error) {
        console.log(error);
      }
    },
    toPlayerDetail(userUuid) {
      this.$router.push({
        path: `/player-detail/${userUuid}`
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
@function doublePx($value) {
  @return $value * 2;
}
.activity-box {
  width: 100%;
  background-color: #FFD29C;
  overflow: auto;
  text-align: center;
  font-size: 0;
  .main {
    position: relative;
    display: inline-block;
    width: 980px;
    text-align: left;
    > .bg {
      width: 100%;
    }
    .portrait1,
    .portrait2 {
      position: absolute;
      top: 529px;
      height: auto;
    }
    .portrait1 {
      width: 135px;
      left: 113px;
    }
    .portrait2 {
      width: 129px;
      left: 288.89px;
    }
    .score-box1,
    .score-box2 {
      position: absolute;
      top: 1485px;
      left: 200px;
      font-size: 20px;
      font-weight: 600;
      color: white;
      .item {
        height: 118px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 24px;
        width: 634px;
        .left {
          display: flex;
          align-items: center;
          width: 1px;
          flex: auto;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .right {
          white-space: nowrap;
          min-width: 180px;
        }
        .score {
          display: inline-block;
        }

        img {
          width: 53px;
          height: 53px;
          object-fit: cover;
          border-radius: 50%;
          border: 3px solid black;
          z-index: 1;
          position: relative;
          background-color: white;
          &:nth-child(2) {
            margin-left: -10px;
            z-index: 2;
            margin-right: 18px;
          }
        }
        .user-name {
          display: inline-block;
          // min-width: 80px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .score-box1 {
      .item {
        &:last-child {
          color: black;
        }
      }
    }
    .score-box2 {
      top: 1892px;
      left: 151px;
      height: 280px;
      overflow: auto;
      color: black;
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
      &::-webkit-scrollbar {
        display: none;
      }
      .item {
        height: 91px;
        margin-bottom: 0;
        width: 683px;
        .index {
          display: inline-block;
          margin-right: 23px;
        }
        img {
          width: 53px;
          height: 53px;
          &:nth-child(2) {
            margin-left: 0;
            z-index: 1;
            margin-right: 0;
          }
          &:nth-child(3) {
            margin-left: -10px;
            z-index: 2;
            margin-right: 18px;
          }
        }
      }
    }
    .my-score {
      position: absolute;
      top: 2201px;
      left: 306px;
      font-size: 30px;
      font-weight: bold;
      color: white;
    }
  }
}
</style>
